import axios from "./axios"

/**
 * VSS-檢查服務准入條件,並返回輔助填寫資料
 * @param {*} serviceType 
 * @param {*} identType 
 * @param {*} identNo 
 * @param {*} spNo 
 * @param {*} registrationNo 
 * @param {*} identificationNo 
 * @param {*} isFirst 
 * @returns 
 */
const getVss = (serviceType, identType, identNo, spNo, registrationNo, identificationNo, isFirst = true) => {
    return axios.post(`/protected/api/v1/application/hzmb/${serviceType}?identType=${identType}&identNo=${identNo}&${spNo ? `spNo=${spNo}` : `registrationNo=${registrationNo}&identificationNo=${identificationNo}`}${!isFirst ? `&isFirst=${isFirst}` : ''}`).then(res => res.data)
}

/**
 * 補交文件
 * @param {*} serviceType 
 * @param {*} applicationId 
 */
const supplement = (serviceType, applicationId) => {
    return axios.post(`/protected/api/v1/application/hzmb/${serviceType}/${applicationId}/supplement`).then(res => res.data)
}

/**
 * 查詢車輛資料
 * @param {*} serviceType 
 * @param {*} registrationNo 
 * @param {*} identificationNo 
 * @param {*} captcha 
 */
const vehicle = (serviceType, registrationNo, identificationNo, captcha) => {
    return axios.get(`/public/api/v1/application/${serviceType}/vehicle?registrationNo=${registrationNo}&identificationNo=${identificationNo}&captcha=${captcha}`).then(res => res.data)
}

/**
 * 刪除文件
 * @param {*} serviceType 
 * @param {*} applicationId 
 * @param {*} id 
 * @returns 
 */
 const delFile = (serviceType, applicationId, id) => {
    return axios.delete(`/protected/api/v1/application/hzmb/delete/file/${serviceType}/${applicationId}/${id}`).then(res => res.data)
}

/**
 * 下載文件
 * @param {*} serviceType 
 * @param {*} applicationId 
 * @param {*} id 
 * @returns 
 */
const downloadFile = (serviceType, applicationId, id) => {
    return axios.get(`/protected/api/v1/application/hzmb/download/file/${serviceType}/${applicationId}/${id}`, {
        responseType: 'blob'
    }).then(res => res)
}

/**
 * 下載文件縮略圖
 * @param {*} serviceType 
 * @param {*} applicationId 
 * @param {*} id 
 * @returns 
 */
const downloadThumbFile = (serviceType, applicationId, id) => {
    return axios.get(`/protected/api/v1/application/hzmb/download/thumb/file/${serviceType}/${applicationId}/${id}`, {
        responseType: 'blob'
    }).then(res => res)
}

/**
 * 暫存申請文件
 * @param {*} id 
 * @param {*} file 
 * @param {*} fileValues 
 * @returns 
 */
const saveFile = (serviceType, applicationId, file, fileValue) => {
    let formData = new FormData();
    formData.append("file", file);
    formData.append(
        "fileValue",
        new Blob([JSON.stringify(fileValue)], {
            type: "application/json",
        })
    );
    return axios.post(`/protected/api/v1/application/hzmb/file/${serviceType}/${applicationId}`, formData).then(res => res.data)
}

/**
 * 查詢港珠澳大橋配額首次申請資料
 * @param {*} applicationId 
 */
const firstSearch = applicationId => {
    return axios.get(`/protected/api/v1/application/hzmb/first?applicationId=${applicationId}`).then(res => res.data)
}

/**
 * 查詢港珠澳大橋配額續期申請資料
 * @param {*} applicationId 
 */
const renewSearch = applicationId => {
    return axios.get(`/protected/api/v1/application/hzmb/renew?applicationId=${applicationId}`).then(res => res.data)
}

/**
 * 提交首次申請
 * @param {*} form 
 * @param {*} files 
 * @param {*} fileValues 
 */
 const first = (form) => {
    let formData = new FormData();
    formData.append(
        "form",
        new Blob([JSON.stringify(form)], {
            type: "application/json",
        })
    );
    return axios.post(`/protected/api/v1/application/hzmb/first`, formData).then(res => res.data)
}

/**
 * 獲取通知訊息
 * @param {*} id 
 * @param {*} serviceType 
 * @param {*} messageType 
 * @param {*} parameters 
 */
const message = (id, serviceType, messageType, parameters = {}) => {
    return axios.post(`/protected/api/v1/application/hzmb/preview-message?serviceType=${serviceType}&messageType=${messageType}${id?`&id=${id}`:''}`, parameters).then(res => res.data)
}

/**
 * 查詢港珠澳大橋配額續期申請資料
 * @param {*} applicationId 
 */
const searchRenew = applicationId => {
    return axios.get(`/protected/api/v1/application/hzmb/renew?applicationId=${applicationId}`).then(res => res.data)
}

/**
 * 提交續期申請
 * @param {*} form 
 * @param {*} files 
 * @param {*} fileValues 
 */
 const renew = (form) => {
    let formData = new FormData();
    formData.append(
        "form",
        new Blob([JSON.stringify(form)], {
            type: "application/json",
        })
    );
    return axios.post(`/protected/api/v1/application/hzmb/renew`, formData).then(res => res.data)
}

/**
 * 暫存首次申請
 * @param {*} form 
 * @returns 
 */
 const saveFirst = (form) => {
    let formData = new FormData();
    formData.append(
        "form",
        new Blob([JSON.stringify(form)], {
            type: "application/json",
        })
    );
    return axios.post(`/protected/api/v1/application/hzmb/save/first`, formData).then(res => res.data)
}

/**
 * 暫存續期申請
 * @param {*} form 
 * @returns 
 */
const saveRenew = (form) => {
    let formData = new FormData();
    formData.append(
        "form",
        new Blob([JSON.stringify(form)], {
            type: "application/json",
        })
    );
    return axios.post(`/protected/api/v1/application/hzmb/save/renew`, formData).then(res => res.data)
}

/**
 * 暫存補交文件
 * @param {*} serviceType 
 * @param {*} applicationId 
 * @param {*} file 
 * @param {*} fileValue 
 * @returns 
 */
const saveSupplementFile = (serviceType, applicationId, file, fileValue) => {
    let formData = new FormData();
    formData.append("file", file);
    formData.append(
        "fileValue",
        new Blob([JSON.stringify(fileValue)], {
            type: "application/json",
        })
    );
    return axios.post(`/protected/api/v1/application/hzmb/supplement/file/${serviceType}/${applicationId}`, formData).then(res => res.data)
}

export default {
    getVss,
    supplement,
    delFile,
    downloadFile,
    downloadThumbFile,
    saveFile,
    vehicle,
    firstSearch,
    renewSearch,
    first,
    message,
    searchRenew,
    renew,
    saveFirst,
    saveRenew,
    saveSupplementFile
}